const formatCurrency = (value: number, locale: string, currency: string) => {
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency,
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(value);
};

export { formatCurrency };
